module.exports = "<div class=\"fit rounded-top rounded wizard-card-title-dark custom-style\">\n  <ng-content></ng-content>\n</div>\n"